// "use client"; // This is a client component 👈🏽

import parse from "html-react-parser";
import React from "react";
import reactStringReplace from "react-string-replace";
// import ReactDOMServer from 'react-dom/server';
// import { createRoot } from 'react-dom/client';
// import { flushSync } from 'react-dom';

const DON = [
  "DON!! x10",
  "DON!! x1",
  "DON!! x2",
  "DON!! x3",
  "DON!! x4",
  "DON!! x5",
  "DON!! x6",
  "DON!! x7",
  "DON!! x8",
  "DON!! x9",
];

const DON_MINUS = [
  "DON!! -10",
  "DON!! -1",
  "DON!! -2",
  "DON!! -3",
  "DON!! -4",
  "DON!! -5",
  "DON!! -6",
  "DON!! -7",
  "DON!! -8",
  "DON!! -9",
  "DON!! −10", // special unicode
  "DON!! −1",
  "DON!! −2",
  "DON!! −3",
  "DON!! −4",
  "DON!! −5",
  "DON!! −6",
  "DON!! −7",
  "DON!! −8",
  "DON!! −9",
];

const BLUE_KEYWORDS = [
  "Opponent's Turn",
  "Activate:Main",
  "Activate: Main",
  "On Your Opponent's Attack",
  "When Attacking",
  "On Play",
  "On K.O.",
  "Your Turn",
  "Main",
  "On Block",
  "End of Your Turn",
];

const RED_KEYWORDS = ["Counter"];

const ROSE_KEYWORDS = ["Once Per Turn"];

const ORANGE_KEYWORDS = ["Rush", "Blocker", "Banish", "Double Attack"];

const YELLOW_KEYWORDS = ["Trigger"];

const KEYWORDS = [
  ...DON,
  ...BLUE_KEYWORDS,
  ...RED_KEYWORDS,
  ...ROSE_KEYWORDS,
  ...ORANGE_KEYWORDS,
  ...YELLOW_KEYWORDS,
];

// For text like (1) where you can activate an effect by resting DON
const REST_DON = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

const COMMON_CLASS_NAMES =
  "flex text-sm inline-block items-center justify-center h-6 px-2 outline outline-1 outline-offset-[-1px]";
const COMMON_CLASS_COLORS = "text-slate-100 outline-slate-100";
const CONTAINER_CLASS_NAMES = "inline-block align-middle relative mr-1";
const TOP_DISPLACEMENT = "top-[-2px]";

// https://react.dev/reference/react-dom/server/renderToString#removing-rendertostring-from-the-client-code
// async function simpleRenderToString(element: React.ReactElement) {
//     const div = document.createElement('div');
//     const root = createRoot(div);
//     flushSync(() => {
//         root.render(element);
//     });
//     return div.innerHTML;
//   }
export function DonMinus() {
  return (
    <div className={CONTAINER_CLASS_NAMES}>
      <div
        className={`bg-purple-700 rounded-lg ${COMMON_CLASS_NAMES} ${COMMON_CLASS_COLORS}`}
      >
        DON!! −
      </div>
    </div>
  );
}

export function MiniKeyword(keyword: string) {}

export function replaceKeywords(
  description: string,
  topDisplacement: boolean = true,
): React.ReactNode[] {
  // First, replace literal \n sequences with actual newlines
  let processedDescription = description.replace(/\\n/g, "\n");

  let replacedText = reactStringReplace(processedDescription);
  for (var i in KEYWORDS) {
    const keyword = KEYWORDS[i];
    replacedText = reactStringReplace(
      replacedText,
      "[" + keyword + "]",
      (match, i) => (
        <Keyword
          keyword={keyword}
          key={keyword + i}
          topDisplacement={topDisplacement}
        />
      ),
    );
  }

  for (var i in DON_MINUS) {
    const keyword = DON_MINUS[i];
    replacedText = reactStringReplace(replacedText, keyword, (match, i) => (
      <Keyword
        keyword={keyword}
        key={keyword + i}
        topDisplacement={topDisplacement}
      />
    ));
  }

  for (var i in REST_DON) {
    const keyword = REST_DON[i];
    replacedText = reactStringReplace(
      replacedText,
      "(" + keyword + ")",
      (match, i) => <DONCircle value={keyword} key={keyword + i} />,
    );
  }

  let retText = [];
  for (let val of replacedText) {
    if (typeof val === "string") {
      // Handle newlines by splitting and creating separate elements
      const lines = val.split("\n");
      lines.forEach((line, index) => {
        if (index > 0) {
          // Add a line break before each line except the first
          retText.push(<br key={`br-${index}`} />);
        }
        if (line.trim() !== "") {
          retText.push(parse(line));
        }
      });
    } else {
      retText.push(val);
    }
  }

  return retText;
}

function DONCircle({ value }: { value: string }) {
  return (
    <div className="inline-block ml-[-4px]">
      <div className="w-6 h-6 text-slate-700 font-bold bg-slate-200 rounded-full outline outline-slate-700 outline-offset-[-1px] outline-1 justify-center items-center flex relative">
        <div className="relative">{value}</div>
      </div>
    </div>
  );
}

function getContainerClassNames(topDisplacement: boolean) {
  return `${CONTAINER_CLASS_NAMES} ${topDisplacement && TOP_DISPLACEMENT}`;
}

export default function Keyword({
  keyword,
  topDisplacement,
}: {
  keyword: string;
  topDisplacement: boolean;
}) {
  if (keyword.includes("DON!! x")) {
    return (
      <div className={getContainerClassNames(topDisplacement)}>
        <div
          className={`bg-black rounded-lg ${COMMON_CLASS_NAMES} ${COMMON_CLASS_COLORS}`}
        >
          {keyword}
        </div>
      </div>
    );
  }

  if (keyword.includes("DON!! -") || keyword.includes("DON!! −")) {
    return <div className="font-bold inline-block">{keyword}</div>;
  }

  if (BLUE_KEYWORDS.some((x) => keyword.includes(x))) {
    return (
      <div className={getContainerClassNames(topDisplacement)}>
        <div
          className={`bg-sky-700 rounded-lg ${COMMON_CLASS_NAMES} ${COMMON_CLASS_COLORS}`}
        >
          {keyword}
        </div>
      </div>
    );
  }

  if (RED_KEYWORDS.some((x) => keyword.includes(x))) {
    return (
      <div className={getContainerClassNames(topDisplacement)}>
        <div
          className={`bg-red-500 rounded ${COMMON_CLASS_NAMES} ${COMMON_CLASS_COLORS}`}
        >
          {keyword}
        </div>
      </div>
    );
  }

  if (ROSE_KEYWORDS.some((x) => keyword.includes(x))) {
    return (
      <div className={getContainerClassNames(topDisplacement)}>
        <div
          className={`bg-rose-500 rounded-full ${COMMON_CLASS_NAMES} ${COMMON_CLASS_COLORS}`}
        >
          {keyword}
        </div>
      </div>
    );
  }

  if (ORANGE_KEYWORDS.some((x) => keyword.includes(x))) {
    return (
      <div className={getContainerClassNames(topDisplacement)}>
        <div
          className={`bg-orange-500 rounded ${COMMON_CLASS_NAMES} ${COMMON_CLASS_COLORS}`}
        >
          {keyword}
        </div>
      </div>
    );
  }

  if (YELLOW_KEYWORDS.some((x) => keyword.includes(x))) {
    return (
      <div className={getContainerClassNames(topDisplacement)}>
        <div
          className={`bg-yellow-300 rounded text-black font-normal ${COMMON_CLASS_NAMES}`}
        >
          {keyword}
        </div>
      </div>
    );
  }
}
